import React from 'react'
import AdminRoleListingComponent from '../../Components/adminRoleListingComponent'

const RoleListingPage = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminRoleListingComponent />
      </div>
    </div>

  )
}

export default RoleListingPage